"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateExistence = void 0;
var validateExistence = exports.validateExistence = function validateExistence(_ref) {
  var value = _ref.value;
  return {
    error: typeof value === 'string' && value.trim().length === 0
  };
};